import React from "react"
import {FieldGraphTickLabelViewProps} from "../../render/graph-tick-label"
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"

export default function Field_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    const value         = props.field.getViewValue(props.model)

    const hintName = _.get(props, 'hintName', props.field.groupLabel(value))
    const hint = '{0}: {1}'.f(hintName, props.params.dataRecord.value)

    const classes = Classes("flex-row-center-center m-l-5 m-r-5", props.className)

    return (
        <div className={classes}>
            {!props.children && <div className="ui5-txt-default txt-truncate">{props.field.groupLabel(value)}</div>}

            {props.children}

            <HintPopover hint={hint}/>
        </div>
    )
}